import { HttpService } from "@/core";
import { detailResp, ExportReq, ExportResp } from "@/core/interface";
import {
  CheckDetailResp,
  CheckPageReq,
  CheckPageResp,
  CheckReq,
  CheckSimpleListReq,
  CheckSimpleListResp,
} from "./check.interface";

export class CheckService {
  static usePageApi() {
    const api = (params: CheckPageReq) =>
      HttpService.axios({
        method: "GET",
        url: "/quality_check/page",
        params,
      });
    return HttpService.usePagination<CheckPageResp>(api);
  }

  static useDetailApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `/quality_check/${id}`,
      });
    return HttpService.useRequest<CheckDetailResp>(api);
  }

  static useCreateApi() {
    const api = (data: CheckReq) =>
      HttpService.axios({
        method: "POST",
        url: "/quality_check",
        data,
      });
    return HttpService.useRequest<detailResp>(api);
  }

  static useEditApi() {
    const api = (id: string, data: CheckReq) =>
      HttpService.axios({
        method: "PUT",
        url: `/quality_check/${id}`,
        data,
      });
    return HttpService.useRequest<detailResp>(api);
  }

  static useDeleteApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "DELETE",
        url: `/quality_check/${id}`,
      });
    return HttpService.useRequest<void>(api);
  }

  static useExportApi() {
    const api = (ids: ExportReq) =>
      HttpService.axios({
        method: "GET",
        url: "/quality_check/export",
        params: { ids },
      });
    return HttpService.useRequest<ExportResp>(api);
  }

  static useSimpleListApi() {
    const api = (params: CheckSimpleListReq) =>
      HttpService.axios({
        method: "GET",
        url: "/quality_check/simple/list",
        params,
      });
    return HttpService.useRequest<CheckSimpleListResp>(api);
  }

  static async backfillByCheckId(checkId): Promise<CheckReq> {
    let result = new CheckReq();
    if (!checkId) {
      return result;
    }
    const { run } = CheckService.useDetailApi();
    const res = await run(checkId);
    if (res.respCode === "0000" && res.data) {
      result.pick(res.data);
    }
    return result;
  }
}
